module.exports = __webpack_public_path__ + "images/emoji/euro.426bcbbde7bec62c9cbf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/euro.png
// module id = X3fw
// module chunks = 13